export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    const state = await window.BAO.Cart.addItemFromForm(this.form)

    if (state?.sections) {
      const pushCartSections = window.BAO.sectionRenderer.pushCartSections.map(section => ({
        ...section,
        html: state.sections[section.section]
      }))

      window.BAO.sectionRenderer.renderMultiple(pushCartSections)

      if (window.AndDaughter?.cartDrawer) {
        window.AndDaughter.cartDrawer().open()
      }
    }

    return state
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
